var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"jwt-auth-form text-center"},[_vm._m(0),_c('p',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.$t('auth.jwt.authenticating')))])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mb-4"},[_c('div',{staticClass:"spinner-border text-primary",attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Loading...")])])])
}]

export { render, staticRenderFns }